import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Separator,
  Image,
  Heading,
  Box,
  Flex,
  Text,
  Badge,
} from "@chakra-ui/react";

interface ICTACard {
  name?: string;
  title?: string;
  desc?: string;
  badge?: boolean;
  badgeCopy?: any;
  buttonCopy?: any;
  buttonLink?: any;
  buttonOnClick?: any;
  onConfirmation?: any;
  index?: number;
  check?: string;
  addInformation?: any;
  logo?: any;
  onClick?: any;
}

const CTACardWithConfirmation: React.FC<ICTACard> = ({
  name,
  title,
  desc,
  badge,
  badgeCopy,
  buttonCopy,
  buttonOnClick,
  onConfirmation,
  index,
  check,
  addInformation,
  logo,
}: ICTACard) => {
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    onConfirmation(index, validated);
  }, [validated]);

  const onClick = async () => {
    const added = await buttonOnClick();
    setValidated(added);
  };

  return (
    <Flex bg="white" flexWrap="wrap">
      <Box p="32px">
        <Box display="flex" justifyContent="flex-start" alignItems="flex-start">
          <Heading as="h3" fontSize="24px" mr="16px">
            {title}
          </Heading>
          {badge && (
            <Badge
              borderRadius="0px"
              bg="#8142D5"
              color="white"
              textTransform="none"
            >
              {badgeCopy}
            </Badge>
          )}
        </Box>
        <Text fontSize="16px" mt="16px" mb="32px">
          {desc}
        </Text>
        {/* TODO: add styling */}
        <Button variant="outline" onClick={() => onClick()}>
          {buttonCopy}
          {logo && <Image src={logo} pl="8px" boxSize="32px" alt="Palm" />}
        </Button>
        {addInformation}
      </Box>
      <Separator borderColor="palmNetwork.100" />
      <Flex pt="32px" pb="32px" justifyContent="center" margin="auto">
        <Checkbox.Root
          key={`Check-${name}`}
          onCheckedChange={(e) => setValidated(!!e.checked)}
          checked={validated}
        >
          <Checkbox.HiddenInput />
          <Checkbox.Control borderColor="palmNetwork.100" />
          <Checkbox.Label>
            <Box as="span" ml="8px">
              {check}
            </Box>
          </Checkbox.Label>
        </Checkbox.Root>
      </Flex>
    </Flex>
  );
};

export default CTACardWithConfirmation;
